// Header Functions

document.addEventListener(
  "DOMContentLoaded", () => {
    var $menuDesktop = $("#tmt-menu").clone();
    $menuDesktop.attr( "id", "tmt-menu-desktop" );
    $('#tmt-menu').after($menuDesktop);
    const menuDesktop = new Mmenu( '#tmt-menu-desktop', {
      // options
      "extensions": [
        "position-front",
        "position-right",
        "multiline"
      ],
      "navbar": false,
      "setSelected": {
        "parent": true
      },
      "navbars": [
        {
          "position": "top",
          "content": [
            'close',
            $("#nav-lang").html(),
        ]
        },
      ],
      "columns": {
        "add": true,
        "visible": { "min": 1, "max": 2 }
      },
      "hooks": {
        "openPanel:start": function( $panel ) {
          //console.log($panel);
        }
      }
    }, {
        // configuration
    });
    const menuMobile = new Mmenu( "#tmt-menu", {
        // options
        "extensions": [
          "position-front",
          "position-right",
          "multiline"
        ],
        "navbars": [
          {
            "position": "top",
            "content": [
              'prev',
              $("#nav-lang").html(),
              'close'
            ]
          },
          {
            "position": "bottom",
            "content": [
              '<p>+49 271 4014-0<br><a href="mailto:contact@tmt.com">contact@tmt.com</a></p>'
            ]
          },
        ],
        "hooks": {
          "openPanel:start": function( $panel ) {
            //console.log($panel.id);
            //console.log($panel.parentElement.firstChild.id);
            if ($panel.id != $panel.parentElement.firstChild.id) {
              //console.log('Ist NICHT das erste Panel');
              $('#tmt-menu .mm-navbars_top').addClass('mm-navbar-sub');
              $('#tmt-menu .mm-navbars_bottom').addClass('mm-hidden');
            } else {
              //console.log('Ist das erste Panel');
              $('#tmt-menu .mm-navbars_top').removeClass('mm-navbar-sub');
              $('#tmt-menu .mm-navbars_bottom').removeClass('mm-hidden');
            }
          }
       }
      }, {
          // configuration
      });
      const apiMenuDesktop = menuDesktop.API;
      const apiMenuMobile = menuMobile.API;
      if ($('#tmt-menu-button').length) {
        document.querySelector( "#tmt-menu-button" )
        .addEventListener(
            "click", ( evnt ) => {
                evnt.preventDefault();
                if ($(window).width() > 991) {
                  apiMenuDesktop.open();
                } else {
                  apiMenuMobile.open();
                }
                
            }
        );
      }
      $(window).on("resize", function() {
        if ($(window).width() < 992) {
          apiMenuDesktop.close();
        } else {
          apiMenuMobile.close();
        }
      });
  }
);


$(document).ready(function(){

  // ##############################################
  // #################### Nav #####################
  // ##############################################
  

  // Sticky-Header und responsive Nav
	if ($(window).width() > 767) {
		var $offsetStickyNav = 110; // $navbar-height-md: 110px;
  } else {
    var $offsetStickyNav = 80; // $navbar-height-xs: 80px;
  }
	  
	$(window).on("resize", function() {
    // Sticky-Header und responsive Nav
    if ($(window).width() > 767) {
      $offsetStickyNav = 110; // $navbar-height-md: 110px;
    } else {
      $offsetStickyNav = 80; // $navbar-height-xs: 80px;
    }
	});

  
  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('header').outerHeight();  

  $(window).scroll(function(event){
      didScroll = true;      
  });

  setInterval(function() {
      if (didScroll) {
          hasScrolled();
          hashVisibilty();
          didScroll = false;
      }
  }, 250);

  function hashVisibilty() {
    if ($('#container .tmt-bg').length) {
      if ($(window).scrollTop() > 500) {
        $('#container .tmt-bg').fadeOut(600,'swing');
      } else {
        $('#container .tmt-bg').fadeIn(600,'swing');
      }  
    }
  }

  function hasScrolled() {
    
    var st = $(window).scrollTop();
  
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) 
      return;
        
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      $('header').removeClass('nav-down').addClass('nav-up');
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('header').removeClass('nav-up').addClass('nav-down');
      }
      if (st < 10) {
        $('header').removeClass('nav-down');
      } 
    }
    lastScrollTop = st;
  }
  
  hasScrolled();
  hashVisibilty();


  // ##############################################
	// #################### Map #####################
	// ##############################################

	$('.map-collapse').on('shown.bs.collapse', function () {
    var parentItem = $(this).closest('section');
    var win = $(window);
    var viewport = {
      top : win.scrollTop(),
    };
    var bounds = parentItem.offset();
    var itemHeight = parentItem.outerHeight();
    if (itemHeight > win.height() || (viewport.top+(win.height())) < bounds.top || bounds.top < viewport.top) {
      var $navOffset = $offsetStickyNav;
      $('html, body').animate({
        scrollTop: ($(parentItem).offset().top - $navOffset)
      }, 800);
    }
  });

  // ##############################################
	// ################# Accordion ##################
	// ##############################################

  $('.accordion .collapse, .product-tooltips .collapse').on('shown.bs.collapse', function (e) {
    if ($(this).hasClass('modal-body')) {
      var id = $(this)[0].id;
      var parentItem = $("#" + id).closest('.product-modal');
    } else {
      var id = $(e.target).parent().find("[id]")[0].id;
      var cardHeader = $("#" + id);
      var parentItem = cardHeader.closest('.card');  
    }
    var win = $(window);
    var viewport = {
      top : win.scrollTop(),
    };
    var bounds = parentItem.offset();
    var itemHeight = parentItem.outerHeight();
    if (itemHeight > win.height() || (viewport.top+(win.height()/2)) < bounds.top || bounds.top < viewport.top) {
      var $navOffset = $offsetStickyNav;
      $('html, body').animate({
        scrollTop: ($(parentItem).offset().top - $navOffset)
      }, 800);
    }
  });


});


// WEBPACK FOOTER //
// ./js/parts/header.js